import React from "react";
import styled from "styled-components";
import SelfServiceReport from "../interfaces/SelfServiceReport";
import ReportCard from "./ReportCard";

const Container = styled.div`
  p {
    text-align: center;
    font-family: Inter, system-ui;
    font-weight: 400;
    font-size: 19px;
    line-height: 25px;
    margin: 0;
    color: #84838d;

    &:first-child {
      margin-top: 4vh;
    }
  }
`;

interface SharedReportListProps {
  searchQuery: string;
  reports: SelfServiceReport[];
  duplicateReport: (report: SelfServiceReport) => Promise<void>;
}

const SharedReportList = (props: SharedReportListProps) => {
  const { searchQuery, reports, duplicateReport } = props;

  if (reports.length === 0) {
    if (Boolean(searchQuery)) {
      return (
        <Container>
          <p>Clear the filter to see all your templates.</p>
        </Container>
      );
    }

    return (
      <Container>
        <p>
          As soon as somebody from your team shares the report, it will be
          reflected here.
        </p>
      </Container>
    );
  }

  return (
    <Container>
      {reports.map((r) => (
        <ReportCard
          key={r.selfServiceReportId}
          report={r}
          duplicateReport={duplicateReport}
        />
      ))}
    </Container>
  );
};

export default SharedReportList;
